import { createSlice } from "@reduxjs/toolkit";
import { IComplaintMessage } from "./types"
import { sendComplainMessageReply } from "./services";

export interface IOrderComplaintMessagesState {
  data: IComplaintMessage[];
  status: string;
  error: any;
  submit: {
    status: string,
    errorMsg?: string
  }
}

export const initialState: IOrderComplaintMessagesState = {
  data: [],
  status: "loading",
  error: {},
  submit: {
    status: ""
  }
}

export const OrderComplaintMessagesSlice = createSlice({
  name: 'complaintMessages',
  initialState,
  reducers: {
    resetState: (state) => {
      state.submit.status = ""
    }
  },
  extraReducers: (builder) => {
    builder
    .addCase(sendComplainMessageReply.pending, (state) => {
      state.submit.status = "loading";
    })
    .addCase(sendComplainMessageReply.fulfilled, (state) => {
      state.submit.status = "success";
    })
    .addCase(sendComplainMessageReply.rejected, (state) => {
      state.submit.status = "error";
    })

  }
})

export const OrderComplaintMessagesReducer = OrderComplaintMessagesSlice.reducer;

export const {resetState} = OrderComplaintMessagesSlice.actions;